export const NO_SUPPORT_CONTRACT = "No Support Contract";

export const SUPPORT_LEVEL_OPTIONS = [
  NO_SUPPORT_CONTRACT,
  "Tier 0",
  "Tier 1",
  "Tier 2",
  "Tier 3",
] as const;

export const normalizeSupportLevel = (
  value: string | null | undefined
): string => {
  if (!value || value === "-") {
    return NO_SUPPORT_CONTRACT;
  }

  const normalized = value.trim().toLowerCase();
  const match = SUPPORT_LEVEL_OPTIONS.find(
    (option) => option.toLowerCase() === normalized
  );

  return match ?? NO_SUPPORT_CONTRACT;
};

export const hasActivePartnerContract = (contractStatus: {
  contract_status: string;
  renewal_due: string;
}): boolean =>
  contractStatus.contract_status !== "-" && contractStatus.renewal_due !== "-";
